import { useComponent } from '../ui-library-provider';

const Privilege = (props) => {
  const { PrivilegeComponent } = useComponent();

  return <PrivilegeComponent {...props} />;
};

export { Privilege };
